// extracted by mini-css-extract-plugin
module.exports = {"markStars":"RatingStars_markStars__1jkOh"};